import axios, { AxiosPromise } from 'axios';

import { IMaterialType } from '../../../@types/model/masterData/materialType/materialType';

export default class MaterialTypeHttpService {
    public static getMaterialTypeData() : AxiosPromise<Array<IMaterialType>> {
        return axios.get(`${API_URL}/v1/MaterialType/GetAllWeb`);
    }

    public static addOrUpdateMaterialType(data : IMaterialType) : AxiosPromise<IMaterialType> {
        return axios.post(`${API_URL}/v1/MaterialType/PostMaterialType`, data);
    }

    public static deleteMaterialType(materialTypeId : number) : AxiosPromise<IMaterialType> {
        return axios.delete(`${API_URL}/v1/MaterialType/Delete`, {
            params : { materialTypeId },
        });
    }
}
